
import CryptoJS from 'crypto-js';

const STATIC_SALT = process.env.REACT_APP_STATIC_SALT || 'default-salt-for-dev-only';

/**
 * Security utilities for authentication and content decryption.
 */
export const security = {
    /**
     * Hash_A (ID пошуку): md5(login + "-" + password)
     * Використовується як ім'я файлу конфігу.
     */
    getHashA(login, password) {
        return CryptoJS.MD5(`${login}-${password}`).toString();
    },

    /**
     * Hash_B (Ключ шифрування): sha256(password + STATIC_SALT)
     * Симетричний ключ AES-256 для .dsl.enc файлів.
     */
    getHashB(password) {
        return CryptoJS.SHA256(password + STATIC_SALT).toString();
    },

    /**
     * Decrypts AES-256 encrypted content using Hash_B.
     */
    decryptContent(encryptedContent, hashB) {
        try {
            const bytes = CryptoJS.AES.decrypt(encryptedContent, hashB);
            const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
            if (!decryptedData) throw new Error('Decryption failed: Empty result');
            return decryptedData;
        } catch (error) {
            console.error('Decryption error:', error);
            throw new Error('Failed to decrypt content. Check your password.');
        }
    },

    /**
     * Encrypts content using AES-256 and Hash_B. (Mainly for Admin Build Pipeline)
     */
    encryptContent(content, hashB) {
        return CryptoJS.AES.encrypt(content, hashB).toString();
    }
};
